import Vue from "vue";
import VueParticles from "vue-particles";
import Particles from "particles.vue";

Vue.use(Particles);

// export default () => {
// 	Vue.use(VueParticles)
// }
